import { Paragraph } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        The Fair Housing Act allows you to state gender preferences when you&apos;ll be sharing living areas with other
        tenants.
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
